<template>
    <component :is="tag" ref="swiperContainer" class="d-flex align-items-center swiper text-body">
        <i ref="swiperChevronLeft" class="bi bi-chevron-left d-none bg-white swiper-button cursor-pointer left"></i>
        <slot name="content">

        </slot>
        <i ref="swiperChevronRight" class="bi bi-chevron-right d-none bg-white swiper-button cursor-pointer right"></i>
    </component>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useWindowSize } from "@vueuse/core";

defineProps({
    tag: String
})

const swiperChevronLeft = ref(null);
const swiperChevronRight = ref(null);
const swiperContainer = ref(null);
const { width, height } = useWindowSize();

const resetChevrons = () => {
    const swiperHeight = swiperContainer.value.offsetHeight;
    const heightWidthNormal = Math.min(Math.ceil(swiperHeight * 0.7), 42);
    const paddingNormal = Math.floor((heightWidthNormal - 14) / 2);

    swiperChevronLeft.value.style.height = swiperChevronLeft.value.style.width =
        swiperChevronRight.value.style.height = swiperChevronRight.value.style.width = heightWidthNormal + "px";

    swiperChevronLeft.value.style.padding = swiperChevronRight.value.style.padding = paddingNormal + "px";

    swiperChevronLeft.value?.classList.remove("d-md-flex");
    swiperChevronRight.value?.classList.remove("d-md-flex");
}

const showHideChevrons = () => {
    if (width < 768) return;
    resetChevrons();
    const scrollWidthLeft = swiperContainer.value.scrollLeft;
    const offsetWidth = swiperContainer.value.offsetWidth;
    const scrollWidth = swiperContainer.value.scrollWidth;
    const swiperHeight = swiperContainer.value.offsetHeight;
    const offsetLeft = swiperContainer.value.offsetLeft;
    const offsetRight = swiperContainer.value.offsetRight;

    const heightWidthNormal = Math.min(Math.ceil(swiperHeight * 0.7), 42);
    const paddingNormal = Math.floor((heightWidthNormal - 14) / 2);
    const widthPaddingDelta = heightWidthNormal + paddingNormal;

    if (scrollWidthLeft + offsetWidth < scrollWidth) {
        swiperChevronRight.value.classList.add('d-md-flex')
        swiperChevronRight.value.style.left = `calc(${offsetWidth - widthPaddingDelta + offsetLeft}px)`;
    }
    if (scrollWidthLeft > 0) {
        swiperChevronLeft.value.classList.add('d-md-flex')
        swiperChevronLeft.value.style.right = `calc(${offsetWidth - widthPaddingDelta + offsetRight}px)`;
    }
}

onMounted(() => {
    swiperContainer.value.addEventListener('mouseover', showHideChevrons);
    swiperContainer.value.addEventListener('scroll', showHideChevrons);
    swiperContainer.value.addEventListener('mouseleave', resetChevrons);

    swiperChevronLeft.value.addEventListener("click", () => {
        swiperContainer.value.scrollTo({
            left: swiperContainer.value.scrollLeft - swiperContainer.value.clientWidth + 150,
            behavior: 'smooth'
        });
    })
    swiperChevronRight.value.addEventListener("click", () => {
        swiperContainer.value.scrollTo({
            left: swiperContainer.value.scrollLeft + swiperContainer.value.clientWidth - 150,
            behavior: 'smooth'
        });
    })
})
</script>